import Template from 'backbone/story/templates/comments/comment.js.hamlc'
import ReplyTemplate from 'backbone/story/templates/comments/comment_reply.js.hamlc'
import CommentEditFormView from 'backbone/story/views/comments/comment_edit_form_view.js'
import Comment from 'backbone/story/models/comment.js'
import InlineCommentUtils from 'utils/story/inline_comment_utils.js'
import CommentUtils from 'utils/story/comment_utils.js'
import ScrollsRoyce from 'utils/story/scrolls_royce.js'
import markdown from 'markdown/lib/markdown.js'
import BackboneDispatcher from 'lib/backbone_dispatcher.js'
import StringUtils from 'utils/platform/string_utils.js'
import Inflector from 'utils/platform/inflector.js'

export default class CommentView extends Backbone.View
  events:
    "click .comment-box-wrapper"          : "onCommentClick"
    "click .comment-box-wrapper textarea" : "onCommentClick"
    "click .js-resolve"                   : "onResolveClick"
    "click"                               : "stopPropagation"
    "click form"                          : "stopPropagation"
    "submit form"                         : "onFormSubmit"
    "click .js-comment-edit"              : "onEditClick"
    "click .js-cancel"                    : "onCancelClick"
    "click .comment-list-screen"          : "onCancelClick"
    "autosize:resized"                    : "adjustCommentPadding"

  initialize: (options) ->
    @options = options
    @comment = options.comment
    @expandable = @options.expandable || false
    @expanded = @options.expanded
    @active = @options.active
    @permittedToComment = window.story.permitted_to_comment || false
    @inlineCommentUtils = new InlineCommentUtils()
    @commentViewMediator = page.get("commentViewMediator")
    @commentCollection = page.get("storyComments")
    @inflector = new Inflector()
    @dispatcher = BackboneDispatcher.get_instance()
    @bindListeners()

  remove: =>
    @unbindListeners()
    super()

  bindListeners: ->
    @listenTo(@comment, "change", @render)

  unbindListeners: ->
    @stopListening(@comment, "change", @render)

  onResolveClick: (e) ->
    @comment.set(
      thread_updated_at: moment().format(),
      resolved: 1,
      text_model_type: @options.text_model_type,
      text_model_id: @options.text_model_id,
      text_model_attribute: @options.text_model_attribute
    )
    @comment.resolve(
      success: () => @dispatcher.trigger(
        "inlineCommentResolved", @comment
      )
    )

  onCommentClick: (e, isEditing) ->
    # If clicked comment is on the sidebar panel,
    # trigger an event to let views know to show associated comment
    # and expand the sidebar comment
    return if CommentUtils.allowClicks(e)
    return unless @expandable
    return if @commentViewMediator.commentInProgress()
    return if @comment.isActive()

    e.stopPropagation()
    @dispatcher.trigger("openComposeTab") if @_anchoredCommentNotVisible()
    @commentViewMediator.sidebarCommentClicked(@comment, isEditing)
    @commentCollection.setActive(@comment) unless @displayAnchored()

    if !@comment.get("thread_read")
      setTimeout =>
        @comment.markThreadRead().done =>
          @dispatcher.trigger("commentRead")
        , 3000

  onEditClick: (e) ->
    e.stopPropagation()
    @onCommentClick(e, true)
    @renderEditView(@comment)

  renderEditView: (comment) =>
    return unless @_triggeredCommentIsComment(comment)
    return if @expandable && @displayAnchored()

    $editFormView = new CommentEditFormView(
      el: @$el.find(".js-comment-body-container"),
      parentView: this
    )

    $editFormView.render()

  onCancelClick: ->
    @commentCollection.removeActive()
    @commentViewMediator.removeCommentView()
    @commentViewMediator.removeCommentForm()

  onFormSubmit: (e) ->
    e.stopPropagation()
    e.preventDefault()
    @$form = $(e.target)
    @$commentBodyField = @$form.find('textarea[name="comment[body]"]')
    @saveReply()
    @$commentBodyField.val("")

  saveReply: ->
    reply = @buildComment()
    reply.save({ token: window.story.remote_token }, error: @onSaveReplyError)

    if reply.validationError
      contently.flash.alert(reply.validationError)
      return

    @comment.set(thread_updated_at: moment().format())
    replies = _.clone @comment.get('children')
    replies.push(reply.attributes)
    @comment.set('children', replies)
    $('.panel-content-wrapper').removeClass('hide-comments')
    @commentCollection.trigger("sync")
    unless @expandable
      $("body").find(".actions-other").addClass("allow-comment")

  onSaveReplyError: (comment, response, options) =>
    if response.statusText == "Unauthorized"
      window.location = "/signin"
    else
      contently.flash.alert "There was an error saving your reply, please try again."
      @comment.set('children', _.reject(@comment.get('children'), (reply) ->
        reply == comment.attributes
      ))

  buildComment: ->
    new Comment(
      story_id: window.story.id,
      parent_id: @$form.find('input[name="comment[parent_id]"]').val(),
      body: @$commentBodyField.val(),
      authorable_avatar_url: contently.ui.current_user.avatar_url,
      authorable_name: contently.ui.current_user.name,
      read: true,
      thread_read: true,
      created_at: moment().format(),
      created_at_friendly: "Just now"
    )

  displayAnchored: ->
    !window.location.href.match(/compare/) &&
      (@comment.isInlineAnchored() || @comment.isVideoAnchored() || @comment.isImageAnchored())

  render: () ->
    @$el.html(
      Template(
        comment: @comment.toJSON(),
        anchored: @displayAnchored(),
        active: @comment.isActive(),
        expanded: @comment.isActive(),
        expandable: @expandable,
        permittedToComment: @permittedToComment,
        inflector: @inflector,
        top: @options.top,
        markdown: markdown,
        boldAllMentionedUsers: CommentUtils.boldAllMentionedUsers,
        replyTemplate: ReplyTemplate,
        selectedTextChanged: @comment.selectedTextChanged(@_currentText()),
        StringUtils: StringUtils
      )
    )

    contently.ui.setup_validation(@$el)

    @delegateEvents @events
    CommentUtils.initCommentMentioning(@$el.find('#comment_body'))
    contently.ui.autosizeTextarea(@$el)
    @focusOnReplyBox() if @comment.isActive()
    return this

  focusOnReplyBox: ->
    $element = @$el.find("textarea")
    if $element.length > 0
      $element.focus()
    else
      offset = @commentViewMediator.offset
      ScrollsRoyce.quickScrollToOffset(offset)

  stopPropagation: (e) ->
    e.stopPropagation() unless CommentUtils.allowClicks(e)

  adjustCommentPadding: ->
    # fix the edge cases where there's not enough room
    # for the comment container to fit the page nicely
    $commentContainer = @$el.find(".comment-list-container")
    commentContainerHeight = $commentContainer.height()
    commentContainerTop = parseFloat($commentContainer.css("top"))

    # 100 and 200 are relative bleeds
    footerTop = $("#page-footer").offset().top - 100
    idealPageHeight = commentContainerTop + commentContainerHeight + 200

    if footerTop < idealPageHeight
      $(".panel").css("padding-bottom", "#{commentContainerHeight}px")

  _currentText: ->
    marks = @inlineCommentUtils.markForId(@comment.get("mark_id"))
    _.map(marks, (mark) -> $(mark).text()).join(" ")

  _triggeredCommentIsComment: (comment) ->
    comment.id == @comment.id

  _anchoredCommentNotVisible: ->
    contentNotVisible = !$(".media.panel").is(":visible")
    contentNotVisible && @displayAnchored()



// WEBPACK FOOTER //
// ./app/javascript/backbone/story/views/comments/comment_view.js.coffee